module.exports = __webpack_public_path__ + "static/media/me.d0815fb0.svg";